/**
 * The main api service
 */
import http from '@util/http';
import {incubator} from '@api/req';

export async function queryIncuOregistappMoveOutList(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_LIST, params);
}

export async function queryIncuOregistappMoveOutMy(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_MY, params);
}

export async function queryIncuOregistappMoveOutInfo(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_INFO, params);
}

export async function querySaveIncuOregistappMoveOut(params) {
  return http.post(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_SAVE, params);
}

export async function queryNextIncuOregistappMoveOut(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_NEXT, params);
}

export async function queryReturnIncuOregistappMoveOut(params) {
  return http.post(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_RETURN, params);
}

export async function queryCallbackIncuOregistappMoveOut(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_CALLBACK, params);
}

export async function queryIncuOregistappMoveOutWorkflow(params) {
  return http.get(incubator.INCUBATOR_OREGISTAPP_MOVE_OUT_WORKFLOW, params);
}



// WEBPACK FOOTER //
// ./src/api/incubator/oregistappMoveOut.js